module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"code":"Request code","copy":"Copy","copied":"Copied","form-sent":"Your request was sent with success!","fill-again":"Fill again","alt":"Form sent"},"pt-BR":{"code":"Código da solicitação","copy":"Copiar","copied":"Copiado","form-sent":"Formulário enviado com sucesso!","fill-again":"Preencher novamente","alt":"Formulário enviado"}}')
  delete Component.options._Ctor
}
